import { getAgentServices } from "../services";
export async function getOrCreatedocumentId() {
    const liveId = await getAgentServices().contextProviders?.getLiveDocumentId?.();
    if (liveId && liveId.trim().length > 0) {
        return liveId;
    }
    throw new Error("No active document ID is available");
}
